import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";
import InfoYellow from "src/assets/images/infoyellow.png";
import { UseAuth } from "src/auth/AuthContext";
import { getLogoComment } from "src/helpers/mixins";
type ParamsAppealResume = {
  commentByUser?: string;
  commentByAdmin?: string;
};
const AppealResume: React.FC<ParamsAppealResume> = ({
  commentByUser,
  commentByAdmin,
}) => {
  const { user } = UseAuth();

  const getText = (role: string) => {
    switch (role) {
      case "user":
        return "Tu transacción está siendo revisada.";
      case "cashier":
        return "La transacción está siendo revisada por petición del usuario.";
      case "admin":
        return "La transacción está siendo revisada por petición del usuario.";
      default:
        return "";
    }
  };
  return (
    <div>
      <div className="mt-4 border border-stone-300 py-10 px-6 md:px-20 rounded-md shadow-md relative">
        {(commentByAdmin?.length || 0) === 0 &&
          <img
            src={InfoYellow}
            className="w-8 md:w-14 absolute right-6 top-8 md:top-8"
            alt="clip"
          />
        }
        {(commentByAdmin?.length || 0) === 0 ?
          <div className="font-bold underline text-base md:text-xl">
            {getText(user?.role || "")}
          </div>
          :
          <div className="font-bold underline flex items-center justify-center lg:justify-start text-xl gap-6">
          El proceso de revisión a finalizado.   <FaCircleCheck className="relative text-green-400" size={28} />
          </div>
        }
        <div className="text-base text-center lg:text-left font-medium py-4 opensans">
          recomendamos seguir el proceso y revisar las comunicaciones enviadas a
          tu correo electrónico registrado <strong>{user?.email || ''}</strong>
        </div>


        {(commentByAdmin?.length || 0) > 0 && (
          <div className="mb-4">
            <div className="py-4 opensans font-light">
              Comentario del servicio al cliente.
            </div>
            <div className=" flex items-center gap-2 bg-white border-gray-400 border shadow-lg  text-left w-fit rounded-md px-4 py-2 text-sm">
             <img src={getLogoComment()} className="w-10" alt="logo" />
              <div>
                <div className="flex font-semibold items-center gap-2">
                  Servicio al cliente{" "}
                  <FaCircleCheck size={22} className="text-yellow-400" />
                </div>
                {commentByAdmin}
              </div>
            </div>
          </div>
        )}

        <div className="text-base bg-gradient-amber w-full lg:w-8/12 px-2 py-2 font-normal rounded-md opensans shadow-lg border-b-2 border-amber-200">
          <div className="text-sm font-light">
            Comentario enviado por el usuario:
          </div>
          <div className="flex items-center gap-2 mt-10">
            <FaQuoteLeft size={18} className="relative -top-2 text-amber-500" />
            {commentByUser}
            <FaQuoteRight
              size={18}
              className="relative -top-2 text-amber-500"
            />
          </div>
        </div>

      </div>
    </div>
  );
};

export default AppealResume;
